import { memo } from 'react';
import { useApiContext } from 'react-easyrocket';
import { StarFilled } from 'src/svg/StarFilled';
import { StarOutlined } from 'src/svg/StarOutlined';
import { GuestControls } from './GuestControls';
import { AuthenticatedControls } from './AuthenticatedControls';

interface GameControlsProps {
  hasDemo?: boolean;
  handlePlay: () => void;
  handleNavigateToDemoGame: () => void;
  handleFavoriteClick: () => void;
  isFavorite?: boolean;
}

const _GameControls = ({
  handleNavigateToDemoGame,
  handlePlay,
  hasDemo,
  handleFavoriteClick,
  isFavorite
}: GameControlsProps) => {
  const { isAuthenticated } = useApiContext();

  return (
    <>
      <div
        onClick={handleFavoriteClick}
        className="absolute right-0 top-0 z-[22] p-1 opacity-0 group-hover:opacity-100">
        {isFavorite ? <StarFilled /> : <StarOutlined />}
      </div>
      <div className="absolute right-0 w-full left-0 top-0 bottom-0 z-20 flex flex-col opacity-0 hover:opacity-100 transition-all duration-200">
        <div className="bg-gc_hover_bg w-full aspect-[173/239] px-1.5 flex flex-col justify-center items-center">
          {!isAuthenticated ? (
            <GuestControls
              hasDemo={hasDemo}
              handleNavigateToDemoGame={handleNavigateToDemoGame}
              handlePlay={handlePlay}
            />
          ) : (
            <AuthenticatedControls
              hasDemo={hasDemo}
              handlePlay={handlePlay}
              handleNavigateToDemoGame={handleNavigateToDemoGame}
            />
          )}
        </div>
      </div>
    </>
  );
};

export const GameControls = memo(_GameControls);
